'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.cjs');
var MetaplexError = require('./MetaplexError.cjs');

/** @group Errors */
class ReadApiError extends MetaplexError.MetaplexError {
  constructor(message, cause) {
    super(message, 'rpc', undefined, cause);
    _rollupPluginBabelHelpers.defineProperty(this, "name", 'ReadApiError');
  }
}

exports.ReadApiError = ReadApiError;
//# sourceMappingURL=ReadApiError.cjs.map
